module.exports = __webpack_public_path__ + "static/img/6.b5d090b.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/11/sp/6.png
// module id = iuhZ
// module chunks = 0